import * as React from "react";
import {
  Text,
  View,
  StyleSheet,
  Image,
  TouchableWithoutFeedback,
  TouchableOpacity,
} from "react-native";

import { useNavigation } from "@react-navigation/native";
import { modifyPartner } from "../redux/actions/PartnerActions";
import GlobalStyles from "../components/GlobalStyles";
import axios from "axios";
import { user_force_refresh } from "../redux/actions/UserActions";
import { disableGenericNotification } from "../redux/actions/UIStateActions";
import { useSelector } from "react-redux";

export default function NotificationScreen({ route }) {
  const navigation = useNavigation();
  const sparkle = require("../assets/res/sparkle.png");
  // const message = route.params.message;

  var notificationLoaded =
    useSelector((state) => state.uistate.genericNotificationLoaded) || false;
  var message =
    useSelector((state) => state.uistate.genericNotificationMessage) || "0";
  var buttonText =
    useSelector(
      (state) => state.uistate.genericNotificationConfirmButtonText
    ) || "0";

  const values = route.params;
  const mode = values.mode;
  var apiData = {
    partnerName: values.partner_name,
    // "partnerStatus" : "active",
    partner_id: values.partnerId,
    partner_type: values.partnerType,
    sub_partner_type: values.subPartnerType || "",
    partner_validation_type: values.validation,
  };

  apiData.payload = {
    partner_custom_field_A: values.partnerCustomValidationFieldA,
    partner_custom_field_B: values.partnerCustomValidationFieldB,
    partner_custom_field_C: values.partnerCustomValidationFieldC,
    partner_custom_field_D: values.partnerCustomValidationFieldD,
    partner_custom_field_E: values.partnerCustomValidationFieldE,
    partner_custom_field_F: values.partnerCustomValidationFieldF,
    partner_custom_field_G: values.partnerCustomValidationFieldG,
    partner_custom_field_H: "",
    partner_custom_field_I: "",
    partner_custom_field_J: "",
  };
  // console.log("values", apiData);

  modifyPartner(values.partner_name, mode, apiData);
  user_force_refresh();

  return (
    <View style={GlobalStyles.containerMB}>
      {notificationLoaded ? (
        <View style={styles.modalContainerF}>
          <View style={styles.modalContainer}>
            <View>
              <Image style={styles.sparkle} source={sparkle} />
            </View>
            <View style={styles.PopupHeader}>
              <Text style={styles.textStyleHeader}>{message}</Text>
            </View>
            <View>
              <TouchableOpacity
                style={styles.SubmitButtonStyle}
                activeOpacity={0.5}
                //onPress={() => navigation.navigate("MainMenu")}
                onPress={() => {
                  navigation.popToTop();
                  disableGenericNotification();
                }}
              >
                <Text style={styles.TextStyle}>{buttonText}</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      ) : (
        <></>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  PopupHeader: {
    paddingBottom: 30,
  },
  modalContainer: {
    backgroundColor: "#FFC72C",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 70,
    borderTopLeftRadius: 70,
    borderTopRightRadius: 70,
    paddingTop: 55,
    paddingLeft: 50,
    paddingRight: 50,
    paddingBottom: 25,
    maxWidth: 400,
  },
  modalContainerF: {
    flex: 1,
    flexDirection: "column",
    marginLeft: 30,
    marginRight: 30,
    justifyContent: "center",
    alignItems: "center",
  },
  SubmitButtonStyle: {
    borderRadius: 50,
    backgroundColor: "#FFFFFF",
    marginLeft: -15,
    paddingLeft: 20,
    paddingRight: 20,
    height: 60,
    justifyContent: "center",
  },
  textStyleHeader: {
    color: "#fff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 16,
  },
  TextStyle: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 14,
  },
  sparkle: {
    position: "absolute",
    top: -70,
    right: -70,
    width: 40,
    height: 40,
  },
});
